import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as Logo } from "../logo/logo.svg";
import { IItems, IFilterData } from "../../@types/types";
import NavItem from "./NavItem";
import { SubMenuItem } from "./SubMenuItem";
import Actions from "../common/Actions";
import ActionDropDown from "./ActionDropDown";
import { useAppState } from "../../context/appContex";
import { ReactComponent as SearchIcon } from "../icons/search.svg";
import GlobalSearch from "./GlobalSearch";
import SearchDropDown from "./SearchDropDown";
import { handleFilter } from "../../utils";
// import { EventContext } from "direflow-component";
import FeatherIcon from "feather-icons-react";

const Header: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<IItems | null>(null);
  const [inputValue, setInputValue] = useState("");
  const [isDropDown, setIsDropDown] = useState(false);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [searchResult, setSearchResult] = useState<IFilterData>({
    quickLinks: [],
    mainItems: [],
  });
  const [top, setTop] = useState(50);

  const [searchValue, setSearchValue] = useState("");
  // const dispatch = useContext(EventContext);

  const headerRef = useRef<HTMLElement>(null);

  const {
    menuData,
    flatenedData,
    isCloseAppDropDownsFromApp,
    setIsCloseAppDropDownsFromApp,
    isGlobalSearchVisible,
    theme,
    setMode,
    setIsGlobalSearchVisible,
  } = useAppState();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const switchTheme = () => {
    const newMode = theme === "light" ? "dark" : "light";

    setMode(newMode);
  };

  const closeGlobalSearch = () => {
    setIsGlobalSearch(false);
    setIsGlobalSearchVisible(false);
    setIsCloseAppDropDownsFromApp(false);
    setSearchValue("");
    setSearchResult({
      quickLinks: [],
      mainItems: [],
    });
  };

  const handleSearch = (searchValue: string) => {
    setSearchValue(searchValue);
    const result = handleFilter(flatenedData, searchValue);

    // console.log("result", result);

    setSearchResult(result);
  };

  const openGlobalSearch = () => {
    setIsDropDown(false);
    setSelectedItem(null);
    setIsGlobalSearch(true);
    setIsCloseAppDropDownsFromApp(false);
    setIsGlobalSearchVisible(true);
  };

  const toggleNavItem = (item: IItems | null) => {
    setInputValue("");
    setIsCloseAppDropDownsFromApp(false);

    if (isDropDown) {
      setIsDropDown(false);
    }

    if (item) {
      if (selectedItem && selectedItem.id === item.id) {
        setSelectedItem(null);
      } else {
        setSelectedItem(item);
      }
    } else {
      setSelectedItem(null);
    }
  };

  const closeSubMenuItem = () => {
    if (selectedItem) {
      setSelectedItem(null);
    }
  };

  const closeSideDropDown = () => {
    if (isDropDown) {
      setIsDropDown(false);
    }
  };

  // const handleKeyDown = useCallback(
  //   (e: KeyboardEvent) => {
  //     if (e.defaultPrevented) {
  //       return; // Should do nothing if the default action has been cancelled
  //     }
  //     let handled = false;
  //     if (e.key !== undefined && e.key.toLowerCase() === "k" && e.metaKey) {
  //       if (!isGlobalSearch) {
  //         openGlobalSearch();
  //         handled = true;
  //       }
  //     } else if (e.keyCode !== undefined && e.keyCode === 75 && e.metaKey) {
  //       if (!isGlobalSearch) {
  //         openGlobalSearch();
  //         handled = true;
  //       }
  //     }

  //     if (handled) {
  //       // Suppress "double action" if event handled
  //       e.preventDefault();
  //     }
  //   },

  //   // eslint-disable-next-line
  //   [isGlobalSearch]
  // );

  // useEffect(() => {
  //   document.addEventListener("keydown", handleKeyDown, false);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown, false);
  //   };
  // }, [handleKeyDown]);

  useEffect(() => {
    if (isCloseAppDropDownsFromApp) {
      closeSubMenuItem();
      closeSideDropDown();
      closeGlobalSearch();
    }

    // eslint-disable-next-line
  }, [isCloseAppDropDownsFromApp]);

  useEffect(() => {
    if (isGlobalSearchVisible) {
      closeSubMenuItem();
      closeSideDropDown();
    } else {
      closeGlobalSearch();
    }
    // eslint-disable-next-line
  }, [isGlobalSearchVisible]);

  useEffect(() => {
    if (headerRef.current) {
      setTop(headerRef.current.offsetHeight);
    }
    // eslint-disable-next-line
  }, [headerRef, headerRef.current]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (headerRef.current) {
        setTop(headerRef.current.offsetHeight);
      }
    });
    // eslint-disable-next-line
  }, [headerRef, headerRef.current]);

  return (
    <nav className='nav' ref={headerRef}>
      <div className='left-item'>
        <div
          className='first-row'
          onClick={() => {
            if (menuData?.system.homeMenuItem.targetUrl) {
              window.location.href = menuData?.system.homeMenuItem.targetUrl;
            }
          }}
        >
          <Logo />
          {/* <div className='divider' /> */}
        </div>
        {isGlobalSearch || isGlobalSearchVisible ? (
          <GlobalSearch
            closeGlobalSearch={closeGlobalSearch}
            handleSearch={handleSearch}
          />
        ) : (
          <div className='nav-item' onClick={openGlobalSearch}>
            <SearchIcon />
          </div>
        )}
        {!isGlobalSearch && !isGlobalSearchVisible && (
          <ul className='second-row'>
            {menuData?.items.map((item, index) => {
              if (item.isVisible) {
                return (
                  <NavItem
                    item={item}
                    isFirst={index === 0}
                    key={item.id}
                    toggleNavItem={toggleNavItem}
                    selectedId={selectedItem?.id || ""}
                  />
                );
              } else {
                return null;
              }
            })}
          </ul>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <FeatherIcon
          icon={theme === "dark" ? "sun" : "moon"}
          style={{ cursor: "pointer", marginRight: "20px" }}
          onClick={switchTheme}
        />
        <Actions
          toggleDropDown={() => {
            if (selectedItem) {
              setSelectedItem(null);
            }

            if (isGlobalSearch || isGlobalSearchVisible) {
              closeGlobalSearch();
            }

            const event = new CustomEvent("close-global-search");
            dispatchEvent(event);

            setIsCloseAppDropDownsFromApp(false);

            setIsDropDown((prev) => !prev);
          }}
        />
      </div>
      {isDropDown && !isCloseAppDropDownsFromApp && (
        // closeSideDropDown={closeSideDropDown}
        <ActionDropDown top={top} />
      )}
      {selectedItem && !isCloseAppDropDownsFromApp && (
        <SubMenuItem
          selectedItem={selectedItem}
          inputValue={inputValue}
          onChange={onChange}
          top={top}
          handleSubMenuClose={() => toggleNavItem(null)}
        />
      )}
      {(isGlobalSearch || isGlobalSearchVisible) &&
        !isCloseAppDropDownsFromApp && (
          <SearchDropDown
            closeGlobalSearch={closeGlobalSearch}
            searchResult={searchResult}
            searchValue={searchValue}
          />
        )}
    </nav>
  );
};

export default Header;
